import React from 'react';
import AdminMasterLayout from '../../../layouts/gcadmin/adminMasterLayout/AdminMasterLayout';
import ManageNotesPage from '../../../subsreens/gcadmin/managenotes/ManageNotesPage';

const AdminManageNotes = () => {
    return(
       <AdminMasterLayout>
        <ManageNotesPage></ManageNotesPage>
       </AdminMasterLayout>
    )
}

export default AdminManageNotes;